import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const contactListDataClassName = DataClassName.CONTACT_LIST_RELATION
const contactListEndpoint = PisaDataClassEndpoint.CONTACT_LIST

export function pisaContactListRelationDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(contactListDataClassName, {
    title: contactListDataClassName,
    restApi: createPisaRestApiConfig(contactListEndpoint),
    attributes,
  })
}
